// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","675":"27c0def0","685":"58c6b362","867":"b8c53be3","960":"b2eaf09e","990":"e5f7d131"}[chunkId] + ".chunk.css";
};